const AmazonCognitoIdentity = require('amazon-cognito-identity-js');

const AwsConfirmPassword = (username, verificationCode, newPassword) => {
  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const userData = {
    Username: username,
    Pool: userPool,
  };

  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

  return new Promise((resolve, reject) => {

    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onFailure(err) {

        reject(err);
      },
      onSuccess() {

        resolve();
      },
    });
  });
};

export {
  AwsConfirmPassword as
  default,
};
